export default "__VITE_ASSET__CqEm_kBd__"